import RefreshSystem from '@atoms/RefreshSystem';
import { View } from '@components/primitives';
import { NavigationContainer } from '@react-navigation/native';
import DeepLinkRedirect from '@screens/DeepLinkRedirect/index.web';
import DowntimeScreen from '@screens/DowntimeScreen';
import React from 'react';
import { ActivityIndicator } from 'react-native';
import styles from './AppWithDowntime.styles';
import StackNavigation from './StackNavigation';
import useDowntimeStatus from './useDowntimeStatus';

const AppWithDownTime = props => {
  const { linking, isDeepLinkRedirect } = props;
  const isDowntime = useDowntimeStatus();

  if (isDowntime === null) {
    return (
      <View style={styles.loaderContainer}>
        <ActivityIndicator size="large" />
      </View>
    );
  }

  if (isDowntime) {
    return <DowntimeScreen />;
  }

  return (
    <NavigationContainer linking={linking}>
      {isDeepLinkRedirect ? (
        <DeepLinkRedirect /> // your standalone redirect screen
      ) : (
        <RefreshSystem>
          <StackNavigation />
        </RefreshSystem>
      )}
    </NavigationContainer>
  );
};

export default AppWithDownTime;
